// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExternalRedirectComponent } from './external-redirect/external-redirect.component';

const promoTermsRoutes: Routes = [
  {
    path: 'promo-terms/vodapay',
    component: ExternalRedirectComponent,
    data: {
      externalUrl: 'https://promosterms.s3.eu-west-3.amazonaws.com/Terms-and-Conditions-Eagle-Liner-&-Intercity-Xpress-Ticket-Purchases-via-Vodapay-Confirmed.pdf'
    }
  },
  {
    path: 'promo-terms/capitec',
    component: ExternalRedirectComponent,
    data: {
      externalUrl: 'https://promosterms.s3.eu-west-3.amazonaws.com/Terms-and-Conditions-Eagle-Liner-&-Intercity-Xpress-Ticket-Purchases-via-Capitec.pdf'
    }
  },
  {
    path: 'promo-terms/fnb',
    component: ExternalRedirectComponent,
    data: {
      externalUrl: 'https://promosterms.s3.eu-west-3.amazonaws.com/Terms-and-Conditions-Eagle-Liner-&-Intercity-Xpress-Ticket-Purchases-via-FNB.pdf'
    }
  },
  {
    path: 'promo-terms/moya',
    component: ExternalRedirectComponent,
    data: {
      externalUrl: 'https://promosterms.s3.eu-west-3.amazonaws.com/Terms-and-Conditions-Eagle-Liner-&-Intercity-Xpress-Ticket-Purchases-via-Moya.pdf'
    }
  },
  {
    path: 'promo-terms/mtn-momo',
    component: ExternalRedirectComponent,
    data: {
      externalUrl: 'https://promosterms.s3.eu-west-3.amazonaws.com/Terms-and-Conditions-Eagle-Liner-&-Intercity-Xpress-Ticket-Purchases-via-MTN-MoMo.pdf'
    }
  },
  {
    path: 'promo-terms/mtn-travelwise',
    component: ExternalRedirectComponent,
    data: {
      externalUrl: 'https://promosterms.s3.eu-west-3.amazonaws.com/Terms-and-Conditions-Eagle-Liner-&-Intercity-Xpress-Ticket-Purchases-via-MTN-Travelwise.pdf'
    }
  },
  {
    path: 'promo-terms/intercape',
    component: ExternalRedirectComponent,
    data: {
      externalUrl: 'https://promosterms.s3.eu-west-3.amazonaws.com/Terms-and-Conditions-Intercape-Promo-Ticket-Purchases-via-QuickBus.pdf'
    }
  }
];

const routes: Routes = [
  ...promoTermsRoutes,

  {
    path: '',
    loadChildren: () =>
      import('app/views/layouts/layouts.module').then(
        m => m.LayoutsModule
      )
  },
  {path: '**', redirectTo: 'error', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
